var getFormattedTimestamp = function (date) { return date.toISOString(); };
/**
 * To get the current timestamp in ISO string format
 * @returns ISO formatted timestamp string
 */
var getCurrentTimeFormatted = function () { return getFormattedTimestamp(new Date()); };
export { getCurrentTimeFormatted, getFormattedTimestamp };
//# sourceMappingURL=timestamp.js.map